import ReactDOM from "react-dom/client";
import { App } from "./App";
import { OpenTabsProvider } from "./OpenTabsProvider";
import {
  logClientError,
  triggerClientErrorForTest,
} from "./utils/clientErrorLogger";

window.addEventListener("error", (event) => {
  void logClientError({
    source: "window.error",
    error: event.error || event.message,
    extra: {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    },
  });
});

window.addEventListener("unhandledrejection", (event) => {
  void logClientError({
    source: "window.unhandledrejection",
    error: event.reason,
  });
});

if (import.meta.env.DEV) {
  (window as any).__triggerClientError = triggerClientErrorForTest;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <OpenTabsProvider>
    <App />
  </OpenTabsProvider>
);
